/*
 * File: d:\projects\AutoFiFront\src\Content\Home\Partners\Partners.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday March 8th 2023 4:16:56 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import style from 'Content/Home/Partners/Partners.module.css';

function Partners(_:any){
    return(
        <React.Fragment>
            <div className={`${style.partners}`}>
                <a href="https://www.financo.fr" target="_blank">
                    <img className={`${style.logoPartners}`} src="/logofinanco.png" alt="Logo Partenaire 1" />
                </a>
            </div>
        </React.Fragment>
    );
}

export default Partners;
